const TennisIcon = ({ color = '#D5DCEB', width = '16', height = '16', ...props }) => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M14.182 13.0781C15.318 11.6968 16 9.92803 16 8C16 6.07197 15.318 4.30324 14.182 2.92192C12.838 4.19745 12 6.00086 12 8C12 9.99914 12.838 11.8025 14.182 13.0781Z"
        fill="currentColor"
      ></path>
      <path
        d="M12.7277 14.4543C11.0452 12.819 10 10.5316 10 8C10 5.46844 11.0452 3.18101 12.7277 1.54571C11.4032 0.573931 9.76863 0 8 0C6.23137 0 4.59679 0.573931 3.27234 1.54571C4.95478 3.18101 6 5.46844 6 8C6 10.5316 4.95478 12.819 3.27234 14.4543C4.59679 15.4261 6.23137 16 8 16C9.76863 16 11.4032 15.4261 12.7277 14.4543Z"
        fill="currentColor"
      ></path>
      <path
        d="M0 8C0 6.07197 0.682046 4.30324 1.81802 2.92192C3.16196 4.19745 4 6.00086 4 8C4 9.99914 3.16196 11.8025 1.81802 13.0781C0.682047 11.6968 0 9.92803 0 8Z"
        fill="currentColor"
      ></path>
    </g>
  </svg>
)

export default TennisIcon
